import {CustomerProfile} from './customerProfile';
import {WishedSolution} from './wishedSolution';
import {Isp} from './isp';
import {PhoneNumbersToBePorted} from './phoneNumbersToBePorted';
import {NewPhoneNumber} from './newPhoneNumber';
import {PPhosted} from './PPhosted';
import {MetaData} from './metaData';
import {BagElement} from './bagElement';
import {FlatRate} from './FlatRate';
import {MicrosoftTeams} from './MicrosoftTeams';
import {ThreeCX} from './ThreeCX';
import {PeoplefoneBundle} from './PeoplefoneBundle';
import {MitelHostedPrice} from './MitelHostedPrice';
import {SipTrunk} from './SipTrunk';
import {Datasim} from './Datasim';
import { SBCplus } from './SBCplus';
import {Mobile} from './Mobile';

export class Offer {
  offerID: number;
  offerNumber: string;
  descriprionOfTheProject: string;
  solutionOfTheProject: string;
  metaData: MetaData[];
  status: string;
  customerProfile: CustomerProfile;
  wishedSolution: WishedSolution;
  PPinternetIPworldcom: Isp;
  PPinternetCyberlink: Isp;
  phoneNumbersToBePorted: PhoneNumbersToBePorted;
  newPhoneNumber: NewPhoneNumber;
  PPhosted: PPhosted;
  businessFlatRateHosted: FlatRate;
  businessFlatRateSipTrunk: FlatRate;
  microsoftTeams: MicrosoftTeams;
  threeCX: ThreeCX;
  peoplefoneBundle: PeoplefoneBundle;
  discount: number;
  followupNotify: boolean;
  deviceBag: BagElement[];
  pfMitelHosted: MitelHostedPrice;
  sipTrunks: SipTrunk[];
  datasims: Datasim[];
  operatorConnect: MicrosoftTeams;
  sbcplus: SBCplus;
  mobiles: Mobile[];


  constructor() {
    this.offerID = 0;
    this.offerNumber = '';
    this.descriprionOfTheProject = '';
    this.solutionOfTheProject = '';
    this.metaData = [];
    this.followupNotify = false;
    this.customerProfile = new CustomerProfile;
    this.wishedSolution = new WishedSolution;
    this.PPinternetIPworldcom = new Isp;
    this.PPinternetCyberlink = new Isp;
    this.phoneNumbersToBePorted = new PhoneNumbersToBePorted;
    this.newPhoneNumber = new NewPhoneNumber;
    this.PPhosted = new PPhosted;
    this.threeCX = new ThreeCX;
    this.peoplefoneBundle = new PeoplefoneBundle;
    this.microsoftTeams = new MicrosoftTeams;
    this.businessFlatRateHosted = new FlatRate;
    this.businessFlatRateSipTrunk = new FlatRate;
    this.pfMitelHosted = new MitelHostedPrice;
    this.sipTrunks = [];
    this.datasims = [];
    this.discount = 0;
    this.deviceBag = [];
    this.status = 'OPEN';
    this.operatorConnect = new MicrosoftTeams;
    this.sbcplus = new SBCplus;
    this.mobiles = [];
  }

  mergeBagElements() {
    const effect = {};
    this.deviceBag.map((element) => {
      if (effect[element.device.id] === undefined) {
        effect[element.device.id] = new BagElement(element.device, element.quantity);
      } else {
        effect[element.device.id].quantity += element.quantity;
        effect[element.device.id].device = element.device;
      }
    });
    const keysArray = Object.keys(effect);
    this.deviceBag = [];
    keysArray.map((key) => {
      this.deviceBag.push(effect[key]);
    });
  }

  generateUpdateObject() {
    return {
      description: this.descriprionOfTheProject,
      solution : this.solutionOfTheProject,
      followupNotify: this.followupNotify,
      devicesDiscountPercent: this.discount,
      options: {
        'internetIpworldcom': this.wishedSolution.PeoplephoneInternetIPworldcom,
        'internetCyberlink': this.wishedSolution.PeoplephoneInternetCyberlink,
        'portedNumbers': this.wishedSolution.PhoneNumbersToBePorted,
        'newNumbers': this.wishedSolution.NewPhoneNumbers,
        'peoplefoneSIPTRUNK': this.wishedSolution.PeoplephoneSIPTRUNK,
        'peoplefoneHosted': this.wishedSolution.PeoplephoneHosted,
        'datasim': this.wishedSolution.Datasim,
        'threeCX': this.wishedSolution.ThreeCX,
        'msTeams': this.wishedSolution.MicrosoftTeams,
        'pfBundle': this.wishedSolution.PeoplefoneBundle,
        'bizFlatRatesHosted': this.wishedSolution.FlatRateHOSTED,
        'bizFlatRatesSipTrunk': this.wishedSolution.FlatRateSIPTRUNK,
        'pfDevices': this.wishedSolution.PeoplephoneDevicesDataBase,
        'myDevices': this.wishedSolution.MyDevicesDataBase,
        'pfMittel': this.wishedSolution.PeoplefoneMittel,
        'operatorConnect': this.wishedSolution.OperatorConnect,
        'sbcplus': this.wishedSolution.SBCplus,
        'mobile' :this.wishedSolution.mobile
      }
    };
  }
}



// WEBPACK FOOTER //
// ./src/models/offer.ts